<script>
export default {
  components: {},
  props: {
    text: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="empty-state-container">
    <h2>We couldn’t find what you’re looking for.</h2>
    <p v-if="text">{{ text }}</p>
    <slot name="subtext" />
    <div class="actions">
      <BaseButton
        type="button"
        class="btn-secondary btn-round"
        @click="$emit('clear-search-filters')"
      >
        Clear Filters
      </BaseButton>
      <slot name="action-btn" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.empty-state-container {
  background: white;
  border-radius: $base-border-radius-lg;
  box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.08);
  display: flex;
  flex-direction: column;
  margin-bottom: 30vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25vh;
  padding: 6rem;
  text-align: center;
  width: 55%;

  p {
    margin-top: 2rem;
  }

  .link-support {
    text-decoration: none;
  }

  .actions {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 2rem;

    ::v-deep .button {
      height: 3.7rem;
      padding-bottom: 0.2rem;
      padding-top: 0.2rem;
      white-space: nowrap;
    }

    ::v-deep .button.btn-secondary {
      margin-right: 1rem;
    }
  }
}
</style>
